var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lyvideowrap"}},[_c('iframe',{attrs:{"name":"videoFrame","src":"static/videoApi/live.html","id":"lyvideoFram","frameborder":"0"}}),_vm._v(" "),_c('Button',{attrs:{"type":"primary","long":""},on:{"click":_vm.Close}},[_vm._v("关闭所有视频")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-703db3f7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/locate/com/locateVideo.vue
// module id = null
// module chunks = 